import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {createNotification, deleteNotification} from "common/actions/notifications";
import Notification from "common/components/partials/notification";
import useAppContext from "common/hooks/use-app-context";
import useQueryParams from "common/hooks/use-query-params";

export default function Notifications() {
  const {dispatch, notifications} = useAppContext();
  const location = useLocation();
  const params = useQueryParams();

  useEffect(() => {
    const content = params.get("message");

    if(content) { dispatch(createNotification({content, type: params.get("type")})); }
  }, [params.get("message")]);

  useEffect(() => {
    const state = location.state || {};
    const {message: content, type} = state;

    if(content) { dispatch(createNotification({content, type})); }
  }, [location.state && location.state.message]);

  useEffect(() => {
    const intervalID = setInterval(() => {
      const now = Date.now();

      notifications
        .filter(({createdAt}) => now - createdAt >= 5000)
        .map(({id}) => dispatch(deleteNotification({id})));
    }, 1000);

    return () => clearInterval(intervalID);
  }, [notifications]);

  return (
    <div className="fixed mt-2 left-4 right-4 top-2 sm:left-auto sm:w-48 z-10">
      {notifications.map(({content, id, type}) => (
        <Notification
          key={id}
          content={content}
          onClose={() => dispatch(deleteNotification({id}))}
          type={type}
        />
      ))}
    </div>
  );
}
